var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "3" } }, [_c("Menu")], 1),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                { staticClass: "border" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "head",
                                      attrs: { cols: "12" }
                                    },
                                    [_c("h4", [_vm._v(":: Clientes")])]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "breadcrumb",
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          attrs: {
                                            to: { name: "BrandListClient" }
                                          }
                                        },
                                        [_vm._v("Clientes por marcas")]
                                      ),
                                      _vm._v(" » "),
                                      _c(
                                        "b-link",
                                        {
                                          attrs: {
                                            to: { name: "ClientListByBrands" }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Lista de clientes " +
                                              _vm._s(this.$route.params.brand)
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        " » " +
                                          _vm._s(_vm.client.first_name) +
                                          " " +
                                          _vm._s(_vm.client.last_name) +
                                          ":\n                    "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-2" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "pb-2 cliente-detalle mb-4" },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "text-left pr-4 pl-4",
                                          attrs: { cols: "12" }
                                        },
                                        [
                                          _c("label", [_vm._v("Nombre:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.client.first_name)
                                            )
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Apellidos:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.last_name))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("DNI:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.rut_w2l))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Teléfono:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.fone1_w2l))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Email:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.email))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Local:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.local_w2l))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Estado:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.state))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Local:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.local_w2l))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Url 1:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.url1_w2l))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Url 2:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.url2_w2l))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Marca:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.brand_w2l))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [
                                            _vm._v("Modelo del auto:")
                                          ]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.model_w2l))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Código SAP:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.sap_w2l))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [
                                            _vm._v("Destino Lead:")
                                          ]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.client.cc_destino)
                                            )
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Tienda:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.store))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [
                                            _vm._v("Código de Origen:")
                                          ]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.client.cod_origen2_w2l)
                                            )
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Precio:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.price_w2l))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Términos:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.client.terms))
                                          ]),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("label", [_vm._v("Creado en:")]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.client.created_at)
                                            )
                                          ]),
                                          _c("br")
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("hr", { staticClass: "my-4" }),
                                  _vm._v(" "),
                                  _c(
                                    "b-btn",
                                    {
                                      attrs: { variant: "success" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.editclient(
                                            _vm.client.id,
                                            _vm.client.brand_w2l
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Editar")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-btn",
                                    {
                                      attrs: { variant: "danger" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.deleteclient(_vm.client.id)
                                        }
                                      }
                                    },
                                    [_vm._v("Eliminar")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d945b28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d945b28","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShowClientByBrand.vue
// module id = null
// module chunks = 